interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-10 z-[80] flex justify-center px-4">
      <div className="animate-fade-up flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-2.5 text-sm text-background-50 shadow-lg">
        <i className="ri-checkbox-circle-fill text-secondary-400"></i>
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}